import { Anchor, Flex, Group, Text } from '@mantine/core';

const FormFooter = ({ t }: any) => {
  return (
    <Flex direction={'column'} align={'center'} mt={40} mb={20} pt={8} style={{ borderTop: '1px solid #33334366' }}>
      <Group gap={4}>
        <Text style={{ fontSize: 11 }}>{t('footer.copyright')}</Text>
        <Anchor href='https://www.webkredit.ch/de/' target='_blank' underline='always' style={{ fontSize: 11, color: 'black' }}>{t('footer.link.website')}</Anchor>
      </Group>
      <Text style={{ fontSize: 11 }}>{t('footer.warning')}</Text>
      <Anchor href='https://www.webkredit.ch/de/' target='_blank' underline='always' style={{ fontSize: 11, color: 'black' }}>{t('footer.link.termsOfUse')}</Anchor>
    </Flex>
  )
}

export default FormFooter;